import React, { FC } from 'react'
import Member from './Member'

const Team: FC<{ team?: any }> = ({ team }) => {
  return team.map((member: any, i: number) => (
    <Member key={`team-member-${i}`} member={member} />
  ))
}

export default Team
